import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ProjectsPage } from "./projects";

export function HomeRedirect() {
  const { auth } = useAuth();

  if (auth?.defaultProjectId) {
    return <Navigate to={`/projects/${auth.defaultProjectId}`} replace />;
  }

  return <ProjectsPage />;
}
